import { Badge, Chip } from "@mui/material";
import { TaskStateEnum } from "../AnnualWheel.types";
import { exhaustiveGuard } from "../../common/utilities";

export interface IAnnualWheelActivityStatusChipProps {
    value: string;
    status: TaskStateEnum;
}

function AnnualWheelActivityStatusChip(props: IAnnualWheelActivityStatusChipProps) {
    function getColor(): [bgColor: string, color: string, dotColor: string] {
        switch (props.status) {
            case TaskStateEnum.Completed:
                return ["#E6FAED", "#36847D", "#2BD5C4"];
            case TaskStateEnum.InProgress:
                return ["#ECFBFD", "#1A8092", "#11CCE5"];
            case TaskStateEnum.Ready:
                return ["#E1E7FD", "#2C2A90", "#353494"];
            case TaskStateEnum.Overdue:
                return ["#FEE4E2", "#FF3F78", "#FF3F78"];
            default:
                exhaustiveGuard(props.status);
        }
    }

    const [bgColor, color, dotColor] = getColor();

    return (
        <Chip
            sx={(theme) => ({
                padding: 1,
                fontSize: theme.typography.pxToRem(12),
                color: color,
                backgroundColor: bgColor,
                "& .MuiBadge-root.MuiChip-icon": {
                    marginRight: "1px",
                },
                "& .MuiBadge-badge": {
                    backgroundColor: dotColor,
                },
            })}
            size={"small"}
            icon={<Badge variant={"dot"} color="primary" />}
            label={props.value}
        />
    );
}

export default AnnualWheelActivityStatusChip;
